<template>
    <div class="page-content">
        <div id="cookies" class="section grow pt-5 pb-5 bg-eggshell">
            <div class="container h-100">
                <div class="d-flex h-100 text-left align-items-center">
                    <div class="w-100">
                        <termly-policy termlyDataId="f2a75369-9dde-4bfe-8b82-5a3b02cc2dbc"></termly-policy>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
  name: 'cookies',
  metaInfo: {
      title: 'Cookie Policy'
  },
  components: {
  },
  mounted(){
  }
}
</script>
